<template>
  <QuestionBody :qsNumber="qsNumber" :nextPage="nextPage" :navigateType="navigateType" :content="content" />
</template>

<script>
import QuestionBody from '@/layout/QuestionBody.vue'
export default {
  name: "Qs2-15",
  components: {
    QuestionBody
  },
  data() {
    return {
      qsNumber: 35,
      navigateType: 'CLICK_NEXT',
      content: {
        componentsType: {
          pc: 'longBtn',
          mobile: 'longBtn'
        },
        titleIcon: require('@/assets/icon/questionIcon/21-Emotion.png'),
        mainTitle: 'The reasons for your anxiety are:',
        btn: [
          [
            {
              text: 'Daily anxiety(from work or life)',
            }
          ],[
            {
              text: 'Menopause anxiety',
              operation: 'add product FM-DIM-101'
            }
          ],[
            {
              text: 'Premenstrual anxiety',
              operation: 'add product FM-EPOIL-101'
            }
          ]
        ],
        hasInput: true
      }
    }
  },
  computed: {
    nextPage: function(){
      if(this.$store.state.qsData[21] && this.$store.state.qsData[21].answer.length>0){
        if(this.$store.state.qsData[21].answer.indexOf('Menstrual problems') !== -1){
          return '/questionnaire/section2/16'
        }else if(this.$store.state.qsData[21].answer.indexOf('Women\'s Health') !== -1){
          return '/questionnaire/section2/18'
        }else{
          return '/questionnaire/section3'
        }
      }else{
        return '/questionnaire/section3'
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
